// src/components/PaymentAccounts/PaymentAccountPicker.jsx
// Botón en el chat del trade: abre tus cuentas guardadas y, al elegir una,
// la inserta (formateada) en el input para revisar y enviar.
import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { FiCreditCard } from 'react-icons/fi';
import { listAccounts, formatAccount } from '../../lib/paymentAccounts';
import './PaymentAccounts.css';

export default function PaymentAccountPicker({ onPick }) {
  const [open, setOpen]         = useState(false);
  const [accounts, setAccounts] = useState(null);   // null = aún no cargado
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [open]);

  const toggle = async () => {
    const next = !open;
    setOpen(next);
    if (next && accounts === null) setAccounts(await listAccounts());
  };

  return (
    <div className="pa-picker" ref={ref}>
      <button type="button" className="pa-picker-btn" onClick={toggle} title="Enviar una cuenta guardada">
        <FiCreditCard /> Cuenta
      </button>
      {open && (
        <div className="pa-picker-menu">
          <div className="pa-picker-menu-title">Enviar cuenta de cobro</div>
          {accounts === null ? (
            <div className="pa-picker-empty">Cargando…</div>
          ) : accounts.length === 0 ? (
            <div className="pa-picker-empty">
              No tenés cuentas guardadas. Agregá una en <Link to="/profile" onClick={() => setOpen(false)}>tu perfil</Link> para enviarla rápido.
            </div>
          ) : (
            accounts.map((a) => (
              <button key={a.id} type="button" className="pa-picker-item" onClick={() => { onPick(formatAccount(a)); setOpen(false); }}>
                <strong>{a.alias} · {a.method}</strong>
                <span>{a.number}</span>
              </button>
            ))
          )}
        </div>
      )}
    </div>
  );
}
